export const EXPERIMENTS = {
    // Keep Sorted by Experiment ID

    // TODO Cleanup Closed Experiment
    GIG_IMAGE_RATIO_CONTAIN: 4232,

    // Relevant Experiments
    CARIBOU_RATING_SCORE_UPDATES: 4268,
    HAWKS_LISTINGS_SIDE_FILTERS: 4405,
    HAWKS_LISTINGS_SELLER_LANGUAGE_SIDE_FILTERS: 4508,
    DOLPHINS_HOURLY_RATE_BANNER_LISTINGS_GUEST: 4605,
    MEERKATS_LISTINGS_TIPS: 4778,
    PIGLETS_PRICE_UPFRONT_GUESTS: 5191,
    ZEBRAS_MP_HOURLY_FILTER: 4736,
    OWLS_FILTER_PLUS_EXPERIMENT: 4772,
    DOLPHINS_LOYALTY_ELIGIBILITY_CELEBRATION_MIGRATION: 4929,
    HAWKS_LISTINGS_STORE_BUILDER_WIZARD_EP: 4894,
    CHEETAHS_BOOK_PUBLISHING: 5142,
    OWLS_GNN_EXP: 5050,
    OWLS_AGENCIES_REVERSE_TEST: 4983,
    CROWS_PRO_CATALOG_NO_RESULTS: 5065,
    CROWS_MP_BFF_EXPANSION: 5159,
    CROWS_FILTERS_MODAL: 5235,
    MIRA_ENTRY_POINTS_V1: 5263,
    COBRAS_PUBLIC_RATING_VARIANCE: 5250,
};
